module.exports = __webpack_public_path__ + "img/msaaq.0b6903cf.svg";